import { JSX } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { goBack } from "~/shared_states/modal";
import { rewardsGif } from "~/assets/assets";

export function HubbleRewardsModal(): JSX.Element {
  const { components } = useTelescopeContext();

  return (
    <div class="flex flex-col bg-background-normal-primary">
      <components.ModalHeader
        size="large"
        title="Hubble rewards"
        description="1 Reward = ₹1 · Always!"
        onClose={() => goBack()}
      />

      <div class="flex flex-col gap-4 px-5 pb-5">
        {/* Rewards GIF/Image */}
        <div class="w-full overflow-hidden rounded-2xl border border-stroke-2 bg-background-normal-secondary">
          <img
            src={rewardsGif}
            alt="Hubble rewards demonstration"
            class="w-full object-cover"
          />
        </div>

        {/* Content */}
        <div class="flex flex-col gap-2">
          <p class="text-para-1-semi-bold text-text-normal-primary">
            Once earned, toggle 'ON' to redeem & get instant discount on brand
            cards
          </p>
          <p class="text-para-3-regular text-text-normal-secondary">
            Use your rewards to get extra off on brand card purchases, while
            enjoying instant discounts or earning more rewards
          </p>
        </div>
      </div>
    </div>
  );
}
